<template>
  <v-text-field
    v-bind="$attrs" v-mask="'+1 (###) ###-####'"
    type="tel"
    :rules="(rules || []).map(x => v => x(parsePhone(v)))"
    v-model="formattedPhone"
    @input="x => $emit('input', parsePhone(x))"
    @paste="onPastePhone"
  >
    <template v-slot:append>
      <country-flag class="my-n1" style="transform: scale(.8);" country="us" />
    </template>
    <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
  </v-text-field>
</template>

<script>
import CountryFlag from '@/components/CountryFlag.vue';

export default {
  name: 'contact-field-phone',

  components: {
    CountryFlag
  },

  props: [ 'value', 'rules' ],

  data() {
    return {
      phone: null,
      formattedPhone: null
    };
  },

  methods: {
    // isValidPhone(v) {
    //   // The phone number is already formatted when this function is called
    //   return (this.noTargetRequired && !v) || !!(v && v.startsWith('+1') && v.length == 12);
    // },

    formatPhone(phone) {
      let s = '';
      if (!phone)
        return s;
      if (phone.length >= 2)
        s += '+1 (' + phone.substr(2, 3);
      if (phone.length >= 5)
        s += ') ' + phone.substr(5, 3);
      if (phone.length >= 8)
        s += '-' + phone.substr(8, 4);
      return s;
    },

    onPastePhone(e) {
      // Extract the last 10 digits to avoid accidentally including the country code
      const text = e.clipboardData.getData('text/plain');
      if (text) {
        e.preventDefault();
        const phone = text.replace(/[^0-9]/g,'').substr(-11);
        const phoneCC = phone.substr(0, 1) == '1' ? phone : '1' + phone;
        e.target.value = phoneCC;
        e.target.dispatchEvent(new Event('input'));
      }
    },

    parsePhone(v) {
      return v && '+' + v.replace(/[^0-9]/g, '');
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.formattedPhone = this.formatPhone(v);
      }
    }
  }
}
</script>
